import { css } from 'lit';

import token from '../../utils/get-token';
import color from '../../utils/get-color-token';

export function styles() {
	return css`
		:host {
			display: block;
			width: 100%;
		}

		:host([dismissed]) {
			display: none;
		}

		.banner {
			background-color: var(
				--m-banner-background-color,
				${color('color-background-secondary')}
			);
			border: var(--m-banner-border, 1px solid ${color('color-border')});
			border-radius: var(--m-banner-border-radius, ${token('border-radius-m')});
			padding-inline: var(--m-banner-padding-x, ${token('spacing-6')});
			padding-block: var(--m-banner-padding-y, ${token('spacing-4')});
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-end;
			gap: ${token('spacing-6')};
		}

		.banner.-success {
			--m-banner-background-color: ${color('color-success-20')};
			--m-banner-border: 1px solid ${color('color-success-20')};
			--m-banner-icon-color: ${color('color-success-60')};
		}

		.banner.-warning {
			--m-banner-background-color: ${color('color-warning-20')};
			--m-banner-border: 1px solid ${color('color-warning-20')};
			--m-banner-icon-color: ${color('color-warning-100')};
		}

		.banner.-danger {
			--m-banner-background-color: ${color('color-danger-20')};
			--m-banner-border: 1px solid ${color('color-danger-20')};
			--m-banner-icon-color: ${color('color-danger-60')};
		}

		.banner.-with-description {
			flex-direction: column;
		}

		.wrapper {
			display: flex;
			gap: ${token('spacing-6')};
			align-items: center;
			flex-grow: 1;
		}

		slot[name='icon'] > m-icon,
		slot[name='icon']::slotted(*) {
			--m-icon-color: var(--m-banner-icon-color, ${color('color-neutral-90')});
			--m-icon-size: var(--m-banner-icon-size, 24px);

			fill: var(--m-banner-icon-color, ${color('color-neutral-90')});
			block-size: var(--m-banner-icon-size, 24px);
			inline-size: var(--m-banner-icon-size, 24px);
		}

		.content {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			gap: ${token('spacing-1')};
		}
	`;
}
